import { useQuery } from '@tanstack/react-query';
import oaiApiClient from '../clients/oai-api/oai-api-client';
import { queryClient } from '../query-client';

export const useSubscriptionsCustomer = () => {
  return useQuery({
    queryKey: ['subscriptions-customer'],
    queryFn: async () => {
      return oaiApiClient.subscriptionsCustomer();
    },
    retry: 1,
  });
};

export const ensureSubscriptionsCustomer = async () => {
  return queryClient.ensureQueryData({
    queryKey: ['subscriptions-customer'],
    queryFn: async () => {
      return oaiApiClient.subscriptionsCustomer();
    },
    retry: 1,
  });
};
